var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"map",staticStyle:{"width":"100% !important","height":"350px","margin-bottom":"20px"},attrs:{"id":"map"},on:{"click":_vm.logOk}},[_c('div',{staticClass:"grid items-center justify-center text-gray-light font-bold text-4xl md:text-6xl pt-36"},[_vm._v("Click to see map")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }